export interface HomeViewWidgetSetting {
    id: string;
    title: string;
    description: string;
}

export interface HomeViewWidgetSettingViewModel extends HomeViewWidgetSetting {
    visible: boolean;
}

export const HOME_VIEW_WIDGET_SETTINGS: HomeViewWidgetSetting[] = [
    {
        id: 'widget-warnings',
        title: 'Warnings widget',
        description: 'Shows or hides the Warnings widget on the home view.',
    },
    {
        id: 'widget-punctuality',
        title: 'Punctuality widget',
        description: 'Shows or hides the Punctuality widget on the home view.',
    },
    {
        id: 'widget-late-departures',
        title: 'Late departures widget',
        description: 'Shows or hides the Late departures widget on the home view.',
    },
    {
        id: 'widget-early-departures',
        title: 'Early departures widget',
        description: 'Shows or hides the Early departures widget on the home view.',
    },
    {
        id: 'widget-ev-soc',
        title: 'EV SoC prognosis widget',
        description: 'Shows or hides the Low SoC prognosis widget on the home view.',
    },
];